var Curriculog = Curriculog || {};

Curriculog.LimitFilter = (function ($, _, Backbone, LimitFilter) {

	LimitFilter = Backbone.View.extend({

		el: function() {
			return $('#limit');
		},

		events: {
			'change': 'execute',
		},

		initialize: function(options) {
			this.params = options.params;
			this.render();
			this.$el.val(this.params.pagingParams.get('limit'));

			// Initialize the select2 plugin
			this.$el.selectWoo({
				theme: 'curriculog'
			});
			var label = this.$el.next().find('.select2-selection--single').attr('aria-labelledby');
			this.$el.next().find('.select2-selection--single').attr('aria-labelledby', this.$el.attr('id') + '-label' + ' ' + label );
		},

		execute: function() {
			// setFilter is necessary if we haven't yet clicked a tab
			// to set the filter scope after the page loads
			this.params.pagingParams.set('limit', this.$el.val());

			// reset page to 1
			this.params.pagingParams.set('page', 1);

			// Broadcast get event
			Backbone.trigger('filter:page');
		}

	});

	return LimitFilter;

})($, _, Backbone, Curriculog.LimitFilter || {});
